"use client";

import { CartProvider } from "@/context/CartContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import CartDrawer from "@/components/ui/CartDrawer";
import DynamicToast from "@/components/ui/DynamicToast";
import ModernDialog from "@/components/ui/ModernDialog";
import AuthForm from "@/components/ui/AuthForm";
import ProfileSettingsDialog from "@/components/ui/ProfileSettingsDialog";

function GlobalAuthModal() {
    const { isAuthModalOpen, closeAuthModal, authModalMode } = useAuth();

    return (
        <ModernDialog
            isOpen={isAuthModalOpen}
            onClose={closeAuthModal}
            title={authModalMode === "register" ? "Sign Up" : "Sign In"}
            description={
                authModalMode === "register"
                    ? "Create your Dream Wedding account to get started."
                    : "Enter your details to access your Dream Wedding account."
            }
        >
            {isAuthModalOpen && <AuthForm />}
        </ModernDialog>
    );
}

function GlobalProfileSettings() {
    const { isProfileSettingsOpen } = useAuth();

    if (!isProfileSettingsOpen) {
        return null;
    }

    return <ProfileSettingsDialog />;
}

export default function ClientShell({ children }) {
    return (
        <AuthProvider>
            <CartProvider>
                {children}
                <CartDrawer />
                <GlobalAuthModal />
                <GlobalProfileSettings />
                <DynamicToast />
            </CartProvider>
        </AuthProvider>
    );
}
